"use client"

import React, { useEffect, useState, useRef } from 'react'
import { makeIntoDollars } from '../../../_global/GlobalFuncs'
import MiniLicensePlate from './MiniLicensePlate'
import BannerLicensePlate from '../AllPurpose/BannerLicensePlate'
import Spacer from '../AllPurpose/Spacer'
import mapPin from '../../assets/images/mapPin.png'
import Image from 'next/image'
import { Camera, X, ChevronDown, ChevronUp, ParkingCircleOff, Gauge, TicketIcon } from 'lucide-react'
import SizableLicensePlate from '../AllPurpose/SizableLicensePlate'

const ExpandedTicket = ({
  ticket,
  dismissDrawer,

  lateTimePeriod,

  dueBarValue,
  incomingLateMessage
}) => {
  /* ───────────── Helper fns ───────────── */
  const formatDate = ({ unixDate }) => {
    const date = new Date(unixDate < 1e12 ? unixDate * 1000 : unixDate)
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
  }

  const calculateUpcomingDueDate = () => {
    const raw = new Date(ticket.unixDueDate * 1000)
    return new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric' }).format(raw)
  }
  const calculatePastDueDate = () => {
    const raw = new Date(ticket.unixDueDate * 1000)
    return new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' }).format(raw)
  }

  const upcomingDueDate = calculateUpcomingDueDate()
  const pastDueDate = calculatePastDueDate()

  /* ───── Accordion state ───── */
  const [openBreakdown, setOpenBreakdown] = useState(false)
  const breakdownRef = useRef(null)


  const getTicketCategoryIcon = (ticketCategory) => {

    switch (ticketCategory) {

      case "Parking":
        return <ParkingCircleOff
          size={22}
          color={'#1f2937'}
          strokeWidth={2}
        />

      case "Camera":
        return <Camera
          size={22}
          color={'#1f2937'}
          strokeWidth={2}
        />

      case "Meter":
        return <Gauge
          size={22}
          color={'#1f2937'}
          strokeWidth={2}
        />

      default:
        return <TicketIcon
          size={22}
          color={'#1f2937'}
          strokeWidth={2}
        />

    }

  }

  return (
    <div className="flex flex-col w-full bg-gray-100 -mt-[10px]">
      {/* ───────────── Header ───────────── */}
      <div className="flex flex-row justify-center">
        <div className="flex flex-col w-full space-y-[-5px]">

          <div className="flex items-center justify-between pt-[5px]">

            <div className="flex items-center gap-x-[10px]">

              <p className="font-tpBold text-[30px] text-gray-800 truncate">
                {makeIntoDollars(ticket.statusQuoPrice)}
              </p>

            </div>

            <div className='relative top-[5px]'>
            <SizableLicensePlate
              stateAndLicensePlate={ticket.carState + '-' + ticket.licensePlate}
              isMobile={true}
              context={'expandedTicket'}
            />
            </div>

          </div>

          <div className='flex flex-row items-center justify-start space-x-[5px] relative bottom-[5px]'>
            {getTicketCategoryIcon(ticket.category)}
            <h1 className="font-tpThin text-[24px] text-gray-800 py-[1px]">
              {ticket.category} ticket
            </h1>
          </div>

          <div className="flex items-center justify-between pb-[10px]">

            {(dueBarValue >= 1) && (
<p className={`text-[18px] font-tpBold text-red-700 bg-[#fcd2d2] rounded-[6px] flex items-center justify-center px-[7.5px] py-[2.5px] truncate`}>
                {lateTimePeriod}
              </p>
            )}

            {dueBarValue < 1 && (
            
              <p className={`text-[16px] font-tpBold text-gray-800 bg-yellow-200 rounded-[6px] flex items-center justify-center px-[7.5px] py-[2.5px] truncate`}>
                {incomingLateMessage}
              </p>
            )}

          </div>
        </div>
        <Spacer />
      </div>

      {/* Divider */}
      {/* <div className="pt-[0px] pb-[7.5px]">
        <div className="w-full h-[2px] bg-gray-300 rounded-full" />
      </div> */}

      {/* ───────────── Ticket Meta ───────────── */}
      <div className="flex flex-col px-[12.5px] pt-[10px] pb-[7.5px] bg-white rounded-[6px] border-[1px] border-gray-300">
        {/* category + ticket # */}
        <div className="w-full flex justify-between items-center">
          <h1 className="font-tpThin text-[16px] text-gray-500">
            {ticket.category} ticket
          </h1>
          <h1 className="font-tpThin text-[16px] text-gray-800">
            #{ticket.ticket}
          </h1>
        </div>
        <div className="py-[5px]"><div className="w-full h-[1px] bg-gray-100" /></div>

        {/* Description */}
        <div className="w-full flex justify-between items-start">
          <h1 className="font-tpThin text-[16px] text-gray-500">Description</h1>
          <h1 className="font-tpThin text-[16px] text-gray-800 text-end">{ticket.description}</h1>
        </div>
        <div className="py-[5px]"><div className="w-full h-[1px] bg-gray-100" /></div>

        {/* Location */}
        <div className="w-full flex justify-between items-center">
          <h1 className="font-tpThin text-[16px] text-gray-500">Location</h1>
          <h1 className="font-tpThin text-[16px] text-gray-800">{ticket.borough}</h1>
        </div>
        <div className="py-[5px]"><div className="w-full h-[1px] bg-gray-100" /></div>

        {/* Issued */}
        <div className="w-full flex justify-between items-center">
          <h1 className="font-tpThin text-[16px] text-gray-500">Issued</h1>
          <h1 className="font-tpThin text-[16px] text-gray-800">
            {formatDate({ unixDate: ticket.unixIssueDate })}
          </h1>
        </div>
        <div className="py-[5px]"><div className="w-full h-[1px] bg-gray-100" /></div>

        {/* Due */}
        <div className="w-full flex justify-between items-center">
          <h1 className="font-tpThin text-[16px] text-gray-500">Due</h1>
          <h1 className="font-tpThin text-[16px] text-gray-800">
            {formatDate({ unixDate: ticket.unixDueDate })}
          </h1>
        </div>
        {/* <div className="py-[5px]"><div className="w-full h-[1px] bg-gray-100" /></div> */}



      </div>

      {/* Divider */}
      {/* <div className="pt-[5px] pb-[7.5px]">
        <div className="w-full h-[2px] bg-gray-300 rounded-full" />
      </div> */}

      {/* ───────────── Cost Breakdown Accordion ───────────── */}
      {/* <div className="w-full mt-[10px]">
        
        <button
          onClick={() => setOpenBreakdown(p => !p)}
          className={`flex w-full items-center justify-between bg-gray-100 px-[12.5px] py-[7.5px] active:opacity-60 select-none ${openBreakdown ? 'rounded-t-[10px] border-b-[0px]' : 'rounded-[10px]'} border-[2px] border-gray-300`}
        >
          <span className="font-tpBold text-[15px] text-gray-800">Cost breakdown</span>
          {openBreakdown
            ? <ChevronUp size={18} strokeWidth={3} className="text-gray-800" />
            : <ChevronDown size={18} strokeWidth={3} className="text-gray-800" />}
        </button>

        <div
          ref={breakdownRef}
          style={{
            maxHeight: openBreakdown ? `${breakdownRef.current?.scrollHeight}px` : '0px',
            transition: 'max-height 0.2s ease-in-out',
            overflow: 'hidden',
          }}
          className={`bg-gray-100 rounded-b-[10px] px-[12.5px] ${openBreakdown ? 'border-t-[0px] border-[2px] border-gray-300' : ''}`}
        >
          <div className="flex flex-col items-center w-full pt-[0px]">
            <div className="flex w-full justify-between">
              <div className="flex flex-col space-y-[2px] items-start">
                <h1 className="font-tpThin text-[15px] text-gray-800">Original fine</h1>
                <h1 className="font-tpThin text-[15px] text-gray-800">Late fees</h1>
                <h1 className="font-tpThin text-[15px] text-gray-800">Processing fees</h1>
              </div>
              <div className="flex flex-col space-y-[2px] items-end">
                <h1 className="font-tpThin text-[15px] text-gray-800">{makeIntoDollars(ticket.original)}</h1>
                <h1 className="font-tpThin text-[15px] text-gray-800">{makeIntoDollars(ticket.lateFee)}</h1>
                <h1 className="font-tpThin text-[15px] text-gray-800">
                  {makeIntoDollars(ticket.potentialPaymentAmount - ticket.statusQuoPrice)}
                </h1>
              </div>
            </div>

            <div className="w-full h-[1px] bg-gray-300 my-[5px]" />

            <div className="flex w-full justify-between mb-[7.5px]">
              <h1 className="font-tpBold text-[15px] text-gray-800">Total</h1>
              <h1 className="font-tpBold text-[15px] text-gray-800">
                {makeIntoDollars(ticket.potentialPaymentAmount)}
              </h1>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  )
}

export default ExpandedTicket
